/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass.js.map